module.exports = __webpack_public_path__ + "img/lv11.14cf2d67.png";